import { TOKEN_KEY } from "@/lib/api";

export async function streamAI(path, body, onChunk) {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) {
    let msg = "Permintaan AI gagal";
    try { msg = (await res.json()).detail || msg; } catch (_) { /* ignore */ }
    throw new Error(typeof msg === "string" ? msg : "Permintaan AI gagal");
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  let final = {};
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.error) { const err = new Error(ev.error); err.meta = ev; throw err; }
      if (ev.t) onChunk(ev.t);
      if (ev.done) final = ev;
    }
  }
  return final;
}

export function fileToJpegBase64(file, max = 1600) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const s = Math.min(1, max / Math.max(img.width, img.height));
      const c = document.createElement("canvas");
      c.width = Math.round(img.width * s);
      c.height = Math.round(img.height * s);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(img.src);
      resolve(c.toDataURL("image/jpeg", 0.85).split(",")[1]);
    };
    img.onerror = () => reject(new Error("File bukan gambar yang didukung (JPG/PNG/WEBP)"));
    img.src = URL.createObjectURL(file);
  });
}
